/* oxlint-disable typescript/no-explicit-any */
export const isEmpty = (val: any) => {
  if (val == null) {
    return false;
  } // Ramda считает null и undefined НЕ пустыми (возвращает false)

  if (typeof val === 'object') {
    return Object.keys(val).length === 0;
  } // Для объектов

  if (typeof val.length === 'number') {
    return val.length === 0;
  } // Для массивов/строк/arguments

  return false;
};
